import { useEffect, useState } from 'react';

import clientInfo from 'common/lib/clientInfo';

import copyMagicLog from 'common/components/CopyMagic/shared/copyMagicLog';
import { useUiResourceContext } from 'common/components/CopyMagic/contexts';
import fetchUserUiState, { FetchUserUiStateResponse } from '../../api/fetchUserUiState';
import updateConversationAssistantOpenedCountUserUIState from '../../api/updateConversationAssistantOpenedCountUserUIState';

type OutcomeType = {
  data: FetchUserUiStateResponse | null;
  error: string | null;
};

const initialOutcome = {
  data: null,
  error: null,
};

const defaultErrorMessage = 'Oops! There was an error. Please refresh the page and try again.';
const unauthorizedError = 'Oops! Your session has expired. Please refresh the page and try again.';

const useConversationAssistantOpenedCountQuery = () => {
  const [outcome, setOutcome] = useState<OutcomeType>(initialOutcome);
  const { setConversationAssistantOpenedCount } = useUiResourceContext();

  useEffect(() => {
    fetchUserUiState()
      .then((response) => {
        const currentCount = response.data.attributes.conversationAssistantOpenedCount;
        const incrementedCount = currentCount + 1;
        updateConversationAssistantOpenedCountUserUIState(incrementedCount);
        setConversationAssistantOpenedCount(incrementedCount);

        setOutcome({ data: response, error: null });
      })
      .catch((error) => {
        const errorStatus: number | undefined = error.response?.status;
        const errorMessage = errorStatus === 401 ? unauthorizedError : defaultErrorMessage;

        setOutcome({ data: null, error: errorMessage });
        copyMagicLog(error, { level: 'error' });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  // ^^ we only want to run this useEffect once per page load.

  return outcome;
};

export default useConversationAssistantOpenedCountQuery;
